import React, { forwardRef, HTMLProps } from "react"
import cx from "clsx"
import { CloseIcon } from "components/Icons"

const CloseButton = forwardRef<
  HTMLButtonElement,
  Omit<HTMLProps<HTMLButtonElement>, `type`>
>(({ className, ...rest }, ref) => (
  <button
    ref={ref}
    type="button"
    className={cx(
      `w-8 h-8 flex justify-center items-center rounded`,
      className
    )}
    aria-label="Close"
    title="Close"
    {...rest}
  >
    <CloseIcon aria-hidden="true" className="w-6 h-6" />
  </button>
))

export default CloseButton
